import { connect } from 'react-redux';

import PriceFacade, { PriceAdapters } from 'Favourites/helpers/PriceFacade';


import { selectIsFormProcessing } from 'Favourites/store/reducers';
import * as forms from 'Favourites/store/constants/formTypes';

const mapStateToProps = (state, ownProps) => {
    const withFamilyDiscount = ownProps.withFamilyDiscount || false;
    const price = new PriceFacade();
    price.setState(state);

    price.setAdapter(PriceAdapters.RetailItemComm);

    if (withFamilyDiscount) {
        price.setPriceType(price.getAdapter().FAMILY_TYPE);
    } else {
        price.setPriceType(price.getAdapter().REGULAR_TYPE);
    }

    const leftToPay = ownProps.withLeftToPay ? price.getLeftToPay() : false;
    const subtotalPrice = price.getOrderTotal();

    const totalPrice = subtotalPrice;

    const totalPriceExclVAT = false;
    const vat = 0;
    const processing = selectIsFormProcessing(state, forms.DeliveryArrangements, forms.ReinitializeCheckout);

    return { totalPrice, totalPriceExclVAT, vat, withFamilyDiscount, leftToPay, processing };
};

export default connect(mapStateToProps);
